///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.mfaUpdateForm = abcsetup.mfaUpdateForm || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.mfaUpdateForm = {
    init: function() {
        abcsetup.setTitle('MFA Update');

        // Init reCAPTCHA mfaUpdateForm
        abcsetup.recaptcha.init('mfaUpdateForm');

        // Bind the update form submit event
        $('#updateMFA').on('submit', function () {
            $(':input[type="submit"]').prop('disabled', true).addClass('disabled manual-disabled');
        });
    },
}
